export default __webpack_public_path__ + "static/media/Nedal.e05a939c.jpg";